
import { HiX } from "react-icons/hi";
import Links from "./components/Links";

import routes from "routes";
import logo from "../../assets/images/logo.svg";
import { useDispatch, useSelector } from "react-redux";
import { setSideBarState } from "../../redux/reducers/sideBarReducer";
import { useEffect } from "react";

const Sidebar = (props: {
  open: boolean;
  onClose: React.MouseEventHandler<HTMLSpanElement>;
}) => {
  const sidebarFlag = useSelector((store: any) => {
    if (
      window.innerWidth > 1200 &&
      store.sideBarStateChange.sideBarState === false
    ) {
      return true;
    } else {
      return store.sideBarStateChange.sideBarState;
    }
  });
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.innerWidth > 1200) {
      dispatch(setSideBarState(true));
    }
  }, [window.innerWidth]);

  return (
    <div
      className={`sm:none duration-300 linear fixed !z-50 flex min-h-full w-[280px] flex-col 
        bg-gradient-to-b from-[#0A0A0F] via-[#0F0F18] to-[#0A0A0F]
        pb-10 shadow-2xl transition-all
        border-r border-cyan-500/10
        backdrop-blur-xl
        md:!z-50 lg:!z-50 xl:!z-0 ${sidebarFlag ? "translate-x-0" : "-translate-x-96"
        }`}
    >
      {/* Close button for mobile */}
      <span
        className="absolute right-4 top-4 block cursor-pointer text-gray-400 hover:text-cyan-400 transition-colors xl:hidden"
        onClick={() => dispatch(setSideBarState(false))}
      >
        <HiX className="h-5 w-5" />
      </span>

      {/* Logo section with glow */}
      <div className="flex items-center justify-center px-6 pt-8 pb-6">
        <div className="relative">
          <div className="absolute inset-0 bg-cyan-500/20 blur-xl rounded-full" />
          <img
            className="relative w-full h-auto"
            src={logo}
            alt="TruHail Logo"
          />
        </div>
      </div>

      {/* Gradient divider */}
      <div className="mx-6 h-px bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />

      {/* Navigation links */}
      <ul className="mt-6 flex-1 overflow-y-auto px-4 overflow-x-scroll max-h-[75vh] h-[50vh]">
        <Links routes={routes} />
      </ul>

      {/* Legal links */}
      <div className="px-6 pb-4 pt-2 flex flex-col gap-1 relative z-10">
        <div className="h-px bg-gradient-to-r from-transparent via-cyan-500/20 to-transparent mb-2" />
        <a
          href="/terms-subscriber"
          className="text-xs text-gray-500 hover:text-cyan-400 transition-colors"
        >
          Terms &amp; Conditions
        </a>
        <a
          href="/privacy-policy-subscriber"
          className="text-xs text-gray-500 hover:text-cyan-400 transition-colors"
        >
          Privacy Policy
        </a>
        <p className="text-[10px] text-gray-600 mt-3 text-center">
          Desenvolvido com <span style={{ color: '#EF4444' }}>♥</span> pela Trusom innovation
        </p>
      </div>

      {/* Bottom gradient accent */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-cyan-500/5 to-transparent pointer-events-none" />
    </div>
  );
};

export default Sidebar;

